<template>
  <el-card>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/dashboard/' + $route.params.db }"
        >Panel</el-breadcrumb-item
      >
      <el-breadcrumb-item>Nominas</el-breadcrumb-item>
      <el-button
        type="primary"
        style="float: right"
        size="medium"
        @click="nuevoRegistro()"
      >
        Nuevo
        <i class="el-icon-circle-plus-outline el-icon-right"></i>
      </el-button>
    </el-breadcrumb>
    <br />
    <div class="loading" v-loading="true" v-if="fecthItems.length === 0"></div>
    <template v-else>
      <app-modal-draggable
        v-if="modalDraggable"
        :content="tableQuery"
        :name="'title'"
        :table="'desktop'"
      ></app-modal-draggable>
      <app-table-paginate
        :routeEdit="routeEdit"
        :tableQuery="fecthItems"
        :tableColumns="tableColumns"
        :preview="preview"
        :limit="limit"
        :draggable="true"
        :search="true"
      ></app-table-paginate>
      <br />
      <br />
      <br />
    </template>
  </el-card>
</template>

<script>
import ApiService from "@/common/api.service";
import { INTRANET_URL, API_UPLOADS } from "@/common/config";
import { mapGetters } from "vuex";
import { FECTH_TIPO_TEMPLATE_DESKTOP } from "@/store/actions.type";
import tablaConPaginador from "@/components/_commons/tablaConPaginador";
import Draggable from "@/components/Dashboard/Modals/draggable";
import moment from "moment-timezone";

export default {
  name: "List",
  components: {
    "app-table-paginate": tablaConPaginador,
    "app-modal-draggable": Draggable,
  },
  async created() {
    this.routeEdit =
      "/dashboard/" + this.$route.params.db + "/justificacion_nominas/edit/";
    this.init();
    this.$root.$on("delete", (id) => {
      this.eliminarRegistro(id);
    });
  },

  data() {
    return {
      tableColumns: [
        {
          prop: "name",
          label: "Nombre",
        },
        {
          prop: "document_date",
          label: "Fecha del documento",
          type: "date",
        },
        {
          prop: "cron_date",
          label: "Fecha de aviso a los usuarios",
          type: "datemonth",
        },
      ],
      tableQuery: {},
      searchQuery: "",
      routeEdit: null,
      deleterow: false,
      preview: null,
      templates: false,
      modalDraggable: false,
      limit: 50,
      access: [],
    };
  },
  watch: {
    $route(to) {
      this.routeEdit =
        "/dashboard/" +
        this.$route.params.db +
        "/justificacion_nominas/form/edit/" +
        this.$route.params.table +
        "/";
      this.init();
    },
  },
  methods: {
    async init() {
      await this.getPages();
    },
    nuevoRegistro() {
      this.$router.push(
        "/dashboard/" + this.$route.params.db + "/justificacion_nominas/new"
      );
    },

    async getPages() {
      this.tableQuery = [];

      const a = await ApiService.post("dashboard/table", {
        table: "justificacion_nominas",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
      });
      if (a.data != "Algo ha fallado") {
        a.data.sort((a,b) => new Date(a.cron_date).getTime() - new Date(b.cron_date).getTime()).forEach((element) => {
          element.document_date = moment(element.document_date).tz("Europe/Madrid");
          element.cron_date = moment(element.cron_date).tz("Europe/Madrid");
          this.tableQuery.push(element);
        });
      } else {
        this.tableQuery = {};
      }
    },
    async eliminarRegistro(id) {
      await ApiService.post("dashboard/delete", {
        table: "justificacion_nominas",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: id,
      }).then((response) => {
        this.deleterow = response.data;

        if (this.deleterow == 1) {
          this.$message({
            type: "success",
            message: "Se ha eliminado correctamente",
          });
          this.getPages();
        } else {
          this.$message({
            type: "warning",
            message: this.deleterow,
          });
        }
      });
    },
    showDraggable() {
      this.modalDraggable = true;
    },
    closeModal() {
      this.modalDraggable = false;
      this.init();
    },
  },
  computed: {
    fecthItems() {
      return this.tableQuery;
    },
    ...mapGetters(["userAccessPlugins"]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/justificacion_nominas/list.vue